export const NEWS_QUERY_KEY = "news";
export const NEWS_LIST_QUERY_KEY = "news-list";
export const NEWS_BANNER_QUERY_KEY = "news-banner";
export const HOME_NEWS_QUERY_KEY = "home-news";
export const NEWS_COUNT_PER_PAGE = 15;

export const NEWS_BANNER_VARIANTS = {
  original: "original",
  preview: "preview",
  detail: "detail",
} as const;

export type NewsBannerVariant =
  (typeof NEWS_BANNER_VARIANTS)[keyof typeof NEWS_BANNER_VARIANTS];

export const NEWS_LIST_SORT_FIELDS = {
  dateTimePublishing: "DateTimePublishing",
} as const;

export const HOME_NEWS_COUNT = 6;
